/**
 * Utility for fetching a headline-only list of the latest published stories.
 * Used by the footer's "latest news" block (title + link, no images/metadata).
 */

export type LatestNewsHeadline = {
  id: string;
  headline: string;
  slug: string;
};

const LATEST_NEWS_ENDPOINT = "/api/v1/collections/latest-article-stories";

function mapToHeadlines(items: unknown): LatestNewsHeadline[] {
  if (!Array.isArray(items)) return [];
  const out: LatestNewsHeadline[] = [];
  for (const entry of items as any[]) {
    const story = entry?.story;
    if (!story || typeof story !== "object") continue;
    const slug = story.slug;
    const headline = story.headline;
    if (typeof slug !== "string" || !slug) continue;
    if (typeof headline !== "string" || !headline) continue;
    out.push({
      id: String(story.id || story["story-content-id"] || slug),
      headline: headline.trim(),
      slug,
    });
  }
  return out;
}

export async function getLatestNewsHeadlines(limit = 10): Promise<LatestNewsHeadline[]> {
  try {
    const res = await fetch(`${LATEST_NEWS_ENDPOINT}?limit=${limit}`, {
      cache: "no-store",
    });
    if (!res.ok) return [];
    const data = await res.json();
    return mapToHeadlines(data?.items).slice(0, limit);
  } catch {
    return [];
  }
}
